import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ForHomeownersPage from "@/pages/ForHomeowners";
import ForServiceProvidersPage from "@/pages/ForServiceProviders";
import WaitlistPage from "@/pages/Waitlist";
import ContactPage from "@/pages/Contact";
import NotFoundPage from "@/pages/NotFound";

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/for-homeowners" element={<ForHomeownersPage />} />
                        <Route path="/for-service-providers" element={<ForServiceProvidersPage />} />
                        <Route path="/waitlist" element={<WaitlistPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}
